module.exports = __webpack_public_path__ + "static/media/symbol-defs.e8acf989.svg";